import axios from 'axios';
import { apiHost } from './apiHost';

// Log Aktivitas: mencatat saat struk/tiket/laporan DICETAK dari browser (jendela cetak atau printer Bluetooth). Server mencatat
// "Mencetak struk ORDER-..." dan menandai cetak ulang struk yang sama sebagai PENTING (POST /log-aktivitas/aksi). Gagal mencatat
// tidak pernah mengganggu pencetakan.

const teksBaris = (baris) => {
  const daftar = Array.isArray(baris) ? baris : (baris && Array.isArray(baris.baris) ? baris.baris : []);
  return daftar.map((b) => (b && typeof b.teks === 'string' ? b.teks : '')).join('\n');
};

/** Nomor order di isi cetakan ("ORDER-1792558523287"), atau null. */
export const targetDariBaris = (baris) => {
  const m = teksBaris(baris).match(/ORDER-[0-9A-Za-z]+/);
  return m ? m[0] : null;
};

/** 'cetak_laporan' (struk shift), 'cetak_tiket' (dapur/bar), selain itu 'cetak_struk'. */
export const jenisDariBaris = (baris) => {
  const t = teksBaris(baris);
  if (/SHIFT/i.test(t) && !/ORDER-/.test(t)) return 'cetak_laporan';
  if (/TIKET|DAPUR|KITCHEN/i.test(t) && !/TOTAL/i.test(t)) return 'cetak_tiket';
  return 'cetak_struk';
};

const alamat = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};

/** Catat pembukaan laci kasir lewat tombol "Buka Laci" (PENTING di Log Aktivitas; tanpa menunggu, galat diabaikan). */
export const catatBukaLaci = () => {
  try {
    return Promise.resolve(axios.post(`${alamat()}/log-aktivitas/aksi`, { jenis: 'buka_laci', platform: 'web' }, { withCredentials: true })).then(() => true).catch(() => false);
  } catch (e) {
    return Promise.resolve(false);
  }
};

/** Catat satu pencetakan (tanpa menunggu; galat diabaikan). */
export const catatCetak = (baris) => {
  try {
    const isi = { jenis: jenisDariBaris(baris), platform: 'web' };
    const target = targetDariBaris(baris);
    if (target) isi.target = target;
    return Promise.resolve(axios.post(`${alamat()}/log-aktivitas/aksi`, isi, { withCredentials: true })).then(() => true).catch(() => false);
  } catch (e) {
    return Promise.resolve(false);
  }
};
